export default __webpack_public_path__ + "static/media/Abt.0db5ba61.png";